export default {
	methods: {
		encode_subscribe_parameters(params) {
			return btoa(JSON.stringify(params));
		},

		decode_subscribe_parameters(parameter) {
			return JSON.parse(atob(parameter));
		}
	}
}